import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps} from './Component';
import {Text as TextConstructor} from '@gongxigames/framework/core/fragments/display';
import {TextStyle} from 'pixi.js';

export type TextProps = ComponentProps & {
    maxWidth?: number;
    localeTextID?: string;
    text?: string;
    style: ConstructorParameters<typeof TextStyle>[0];
};

export class Text extends Component<TextProps, TextConstructor> {
    public readonly jsxType: string = 'text';

    static propsFromJson(props: any): TextProps {
        const propsNormalized = {
            ...super.propsFromJson(props),
            style: props.style,
            text: props.text,
            localeTextID: props.localeTextID,
            maxWidth: props.maxWidth
        };

        return propsNormalized;
    }

    public propsToJson(): any {
        const result = super.propsToJson();

        result.style = this.props.style;
        result.text = this.props.text;
        result.localeTextID = this.props.localeTextID;
        result.maxWidth = this.props.maxWidth;

        return result;
    }

    public clone(): Text {
        return new Text(this.props);
    }

    public getConstructor(): new () => any {
        return TextConstructor as any;
    }

    public getNewElement(): TextConstructor {
        return new TextConstructor('');
    }

    public updateProps(context: Context, container: TextConstructor, element: TextConstructor): void {
        const {props} = this;
        const style = new TextStyle(props.style);
        let localization = context.getLocalization(props.localeTextID ?? '');

        if (localization === 'undefined') {
            localization = undefined;
        }

        container.style = style;
        container.text = container.text || localization || props.text || 'undefined';

        super.updateProps(context, container, element);

        if (props.maxWidth) {
            container.maxWidth = props.maxWidth;

            if (!props.anchor?.[0]) {
                container.anchor.x = 0.5;
                container.x += props.maxWidth / 2;
            }
        }
    }
}
